import { Button } from '@/src/components/ui/button'
import { Input } from '@/src/components/ui/input'
import { Label } from '@/src/components/ui/label'
import { Switch } from '@/src/components/ui/switch'
import { useAlertModal } from '@/src/hooks/alert_modal'
import { AdminModal, AdminModalContent, AdminModalFooter, AdminModalHeader, AdminModalMiddle, AdminModalTitle } from '@/src/pages/admin/components/modal'
import { IconPlus } from '@tabler/icons-react'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import useFormValidatonCustom, { validationObject } from '../../../../../../hooks/form_validation_hook'
import { useRESTapi } from '../../../../../../hooks/rest_API'
import { RootState } from '../../../../../../redux/store'
import { Brand, CustomFile, ProductCategory, Shipper, ShipperKeys } from '../../../../../../types'



export type ShipperOverview = Shipper


export function AddShippingSystemModal(
    {
        show,
        closeModal,
        id,
        updateUi,
        mode,
        setShow
    }:
        {
            show: boolean,
            closeModal: () => void,
            id?: string,
            updateUi: () => void,
            mode: 'add' | 'edit',
            setShow: (show: boolean) => any

        }
) {


    const validationObject = {
        [ShipperKeys.I07_Shipper_name]: {
            message: '',
            validation: [
                (value) => {

                    if (!value) {
                        return 'required'
                    }
                    return true
                }
            ]
        },
        [ShipperKeys.I07_image_url]: {
            message: '',
            validation: [
                (value: CustomFile) => {

                    if (value.file || mode === 'edit') {
                        return true
                    }
                    return 'required'
                }
            ]
        },

    } satisfies validationObject

    const api = useRESTapi();
    const employee = useSelector((state: RootState) => state.employee)
    const alertModal = useAlertModal()

    const [formData, setFormData] = useState<ShipperOverview>({
        I07_image_url: '',
        I07_Shipper_name: '',
        I07_is_active: 1,
        I07_Shipper_address_line_1: 'sample'
        // : employee.employeeData.M15_Employee_id ? employee.employeeData.M15_Employee_id : ''
    })
    const [add_progress, set_add_progress] = useState(0)

    const [brands, setBrands] = useState<Brand[]>([])
    const [categories, setCategories] = useState<ProductCategory[]>([])
    const [isLoading, setIsLoading] = useState(false)
    const { performAllValidation, performValidationOf, errorData, setErrorData } = useFormValidatonCustom<Shipper>({
        validationObject: validationObject
    })
    const [loading, set_loading] = useState(false)
    const [imageImage, setImageImage] = useState<{
        imageUrl: string,
        mode: 'local' | 'cloude'
    }>({
        imageUrl: '',
        mode: 'local'
    })
    const image_input_ref = useRef<HTMLInputElement>(null)



    function handleChangeInput(e: React.ChangeEvent<HTMLInputElement>) {

        let formdata: ShipperOverview;

        switch (e.target.name) {

            case ShipperKeys.I07_image_url:

                let total_image: CustomFile
                if (!e.target.files) {
                    formdata = {
                        ...formData,
                        I07_image_url: ''
                    }
                    break;
                }


                const item = e.target.files[0]
                const uniqueId = uuidv4();
                const url = URL.createObjectURL(item)
                total_image = {
                    file: item,
                    id: uniqueId

                }
                formdata = {
                    ...formData,
                    I07_image_url: total_image
                }

                setImageImage({
                    imageUrl: url,
                    mode: 'local'
                })
                break;

            default:
                formdata = {
                    ...formData,
                    [e.target.name]: e.target.value
                }
                break;
        }




        setFormData(formdata)
        performValidationOf(e.target.name, formdata)
        console.log(formdata)

    }

    async function add_brand() {

        setIsLoading(true)
        set_loading(true)
        // formData.M14_M15_created_by = employee.employeeData.M15_Employee_id!
        if (performAllValidation(formData) === true) {
            try {

                const formDataReal = new FormData();
                console.log(formData)
                Object.entries(formData).map(
                    data => {

                        switch (data[0]) {
                            case ShipperKeys.I07_image_url:
                                if (imageImage.mode === 'local') {
                                    const images = data[1] as CustomFile
                                    formDataReal.append(`${data[0]}`, images.file)
                                }
                                break;
                            case ShipperKeys.I07_Shipper_name:
                            case ShipperKeys.I07_Shipper_address_line_1:
                            case ShipperKeys.I07_is_active:
                                formDataReal.append(data[0], String(data[1]))
                                break;

                        }

                    }
                )



                const res = await api.post<{ success: boolean, data: Brand, errors: any, Message: string }>({
                    url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/shippers`,
                    body: formDataReal,
                    mode: 'admin',
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 0))
                        set_add_progress(percentCompleted)
                    }

                })

                if (res.data.success === true) {
                    updateUi();
                    closeModal();

                    alertModal.open_alert_modal({
                        content: res.data?.Message || 'Shipper Created',
                        footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
                        title: 'Created'
                    })
                } else {

                    alertModal.open_alert_modal({
                        content: res.data?.Message || 'something went wrong',
                        footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
                        title: 'Error'
                    })
                    if (res.data.errors) {

                        const errs = res.data.errors;
                        const errData: any = {}

                        for (const key in errs) {
                            errData[key] = errs[key][0]
                        }

                        setErrorData(errData)

                    }
                }

            } catch (error) {
                console.log(error)
                alertModal.open_alert_modal({
                    content: 'Server Error',
                    footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
                    title: 'Error'
                })
            }
        }
        setIsLoading(false)
        set_loading(false)

    }
    async function edit_product() {

        setIsLoading(true)
        // formData.M14_M15_created_by = employee.employeeData.M15_Employee_id!

        if (performAllValidation(formData) === true) {

            try {

                const formDataReal = new FormData();
                formDataReal.append('_method', "PUT")

                Object.entries(formData).map(
                    data => {

                        switch (data[0]) {
                            case ShipperKeys.I07_image_url:
                                if (imageImage.mode === 'local') {
                                    const images = data[1] as CustomFile
                                    formDataReal.append(`${data[0]}`, images.file)
                                }

                                break;

                            case ShipperKeys.I07_Shipper_name:
                            case ShipperKeys.I07_Shipper_address_line_1:
                            case ShipperKeys.I07_is_active:
                                formDataReal.append(data[0], String(data[1]))
                                break;

                        }

                    }
                )






                // const anyFormData  = formData as any

                // for (const key in formData) {
                //     formDataReal.append(key, String(anyFormData[key]))
                // }

                // console.log(images_url_deleted)

                const res = await api.post<{ success: boolean, data: Brand, errors: any, Message: string }>({
                    url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/shippers/${id}`,
                    body: formDataReal,
                    mode: 'admin',
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 0))
                        set_add_progress(percentCompleted)
                    }

                })

                if (res.data.success === true) {
                    updateUi();
                    alertModal.open_alert_modal({
                        content: res.data?.Message || 'Shipper updated',
                        footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
                        title: 'Updated'
                    })
                    closeModal()
                } else {

                    alertModal.open_alert_modal({
                        content: res.data?.Message || 'Something went wrong',
                        footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
                        title: 'Error'
                    })
                    if (res.data.errors) {

                        const errs = res.data.errors;
                        const errData: any = {}

                        for (const key in errs) {
                            errData[key] = errs[key][0]
                        }

                        setErrorData(errData)

                    }
                }
            } catch (error) {
                console.log(error)
                alertModal.open_alert_modal({
                    content: 'Server Error',
                    footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
                    title: 'Error'
                })
            }
        }
        setIsLoading(false)

    }

    const load_shipper = async () => {

        const res = await api.get<{ success: boolean, data: Shipper, message?: string }>({
            url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/shippers/${id}`,
            mode: 'admin',

        })
        if (res.data.success === true) {

            setFormData(res.data.data)
            setImageImage({
                imageUrl: res.data.data.I07_image_url as string,
                mode: 'cloude'
            })
        } else {
            throw res.data
        }


    }



    const clear_data = () => {
        setFormData({
            I07_image_url: '',
            I07_Shipper_name: '',
            I07_is_active: 1,
            I07_Shipper_address_line_1: 'sample'
            // : employee.employeeData.M15_Employee_id ? employee.employeeData.M15_Employee_id : ''
        })
        setErrorData({})
        set_add_progress(0)
        setImageImage({
            imageUrl: '',
            mode: 'local'
        })
    }

    const initEditSetup = () => {
        set_loading(true)
        Promise.all(
            [load_shipper()]
        ).then(
            () => {
                set_loading(false)

            }
        ).catch(
            (err) => {
                set_loading(false)

            }
        )

    }


    useEffect(
        () => {
            const initListSetup = () => {
                set_loading(true)
                clear_data()

                Promise.all(
                    []
                ).then(
                    () => {
                        set_loading(false)
                    }
                ).catch(
                    (err) => {
                        set_loading(false)
                    }
                )

            }

            if (mode === 'add' && show === true) {
                setErrorData({})
                initListSetup()
            } else if (mode === 'edit' && show === true) {
                clear_data()
                initEditSetup()
            } else {
                set_loading(true)

            }


        }, [show]
    )


    const delete_image = () => {
        setImageImage({
            imageUrl: '',
            mode: 'local'
        })
    }

    const onclick_add_image_input = () => {
        image_input_ref.current?.click();
        image_input_ref.current!.value = '';

    }



    return (
        <AdminModal show={show} setShow={(show) => {
            setShow(show)
            if (show === false) clear_data()
        }}  >
            <AdminModalContent disableCloseButton={isLoading} >
                <AdminModalHeader progressValue={add_progress} >
                    <AdminModalTitle>{mode === 'add' ? 'Add Shipper' : 'Edit Shipper'}</AdminModalTitle>
                </AdminModalHeader>
                <AdminModalMiddle>
                    <Label >Name</Label>
                    <Input disabled={loading || isLoading} value={formData.I07_Shipper_name} onChange={handleChangeInput} type="text" name={ShipperKeys.I07_Shipper_name} placeholder='Name' />
                    <div className=' text-red-500'>{errorData.I07_Shipper_name ? errorData.I07_Shipper_name : null}</div>
                    <div className="h-3"></div>

                    <div>Image (Recommended 355 x 213)</div>
                    {
                        <div className=' flex gap-1 max-w-full overflow-auto'>
                            {imageImage.imageUrl ?
                                <div className=' relative w-20- h-20 min-w-20 min-h-20 max-w-20 max-h-20   group'>
                                    <img src={`${imageImage.mode === 'cloude' ? `${process.env.REACT_APP_BACKEND_URL}/${imageImage.imageUrl}` : imageImage.imageUrl}`} alt="" className=' h-full w-full' />
                                    <div className=' absolute inset-0 bg-black/50 z-10 opacity-0 group-hover:opacity-100 flex flex-col items-center justify-center '>
                                        <Button disabled={loading || isLoading} onClick={() => delete_image()} >delete</Button>
                                    </div>
                                </div>
                                : <div onClick={onclick_add_image_input} className=' min-h-20 min-w-20 border-2 border-dotted flex items-center justify-center cursor-pointer' ><IconPlus /></div>}

                            <Input disabled={loading || isLoading} ref={image_input_ref} id='imageInput' className=' hidden' onChange={handleChangeInput} type="file" multiple accept='.png, .jpg' name={ShipperKeys.I07_image_url} placeholder='Image' />
                        </div>
                    }
                    <div className=' text-red-500'>{errorData.I07_image_url ? errorData.I07_image_url as string : null}</div>




                    <div className="h-3"></div>

                    <div className=' flex gap-1'>
                        <Switch
                            disabled={loading || isLoading}
                            checked={formData.I07_is_active == 1 ? true : false}
                            name={ShipperKeys.I07_is_active}
                            onCheckedChange={
                                (checked) => handleChangeInput({
                                    target: {
                                        name: ShipperKeys.I07_is_active,
                                        value: checked ? 1 : '0',
                                        checked: checked
                                    }
                                } as React.ChangeEvent<HTMLInputElement>)
                            }

                        // onChange={handleChangeInput}
                        />
                        <div>is active</div>
                    </div>

                </AdminModalMiddle>
                <AdminModalFooter>
                    <Button disabled={loading || isLoading} variant={'outline'} onClick={closeModal} >Cancel</Button>

                    {
                        mode === 'add' ?
                            <Button disabled={isLoading || loading} onClick={add_brand} >{isLoading ? 'adding...' : 'Add'}</Button>
                            :
                            <Button disabled={isLoading || loading} onClick={edit_product}  >{isLoading ? 'editing...' : 'edit'}</Button>}

                </AdminModalFooter>
            </AdminModalContent>
        </AdminModal>
    )
}
